import { Theme } from '@fluentui/react';
import { ApprovalState } from '../api/generated/data-contracts';

export const getApprovalStateBackground = (state: ApprovalState, theme: Theme) => {
    switch (state) {
        case 'Approved':
            return theme.palette.green;
        case 'Pending':
            return theme.palette.yellow;
        case 'Rejected':
            return theme.palette.red;
        default:
            return theme.semanticColors.disabledBackground;
    }
};
